import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { APP_CONFIG } from '@core/app-config';
import { authInterceptor } from '@core/auth/auth-interceptor';
import { authzInterceptor } from '@core/auth/authz-interceptor';
import { AuthService } from '@core/auth/auth-service';
import { errorInterceptor } from '@core/api/error-interceptor';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: APP_CONFIG, useValue: environment },
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, authzInterceptor])),
    // The access token is never persisted, so every page load starts by refreshing it.
    provideAppInitializer(() => inject(AuthService).restoreSession()),
  ],
};
